import { IPartnerFinSobRow } from '../../model/types'

/** A row only represents realized performance when it's flagged `IsActuals` and NOT also flagged
 *  `IsQuota` — a quota is an externally set target, never a record of actual sales. Rows carrying
 *  both flags (seen in production/mock data) must not be treated as actuals, or they double-count
 *  into actuals-derived sums like the Baseline column. */
export const isActualsFinSobRow = (row: IPartnerFinSobRow): boolean => row.isActuals && !row.isQuota
